import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrIcon from 'client/components/SrIcon';
import SrFlex from 'client/components/SrFlex';

import './SrCollapsibleOption.less';

const SrCollapsibleOption = ({
  title,
  label,
  icon,
  children,
  isActive,
  initialCollapsedState,
  changeBackground }) => {

  const [isCollapsed, setIsCollapsed] = useState(typeof initialCollapsedState === 'boolean'
    ? initialCollapsedState
    : true
  );

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <SrBox
      backgroundColor={changeBackground && isActive ? 'rgba(0, 122, 255, 0.1)' : '#F6F6F6'}
      styleName={classNames('optionContainer')}
    >
      <SrFlex
        align='center'
        width='100%'
        onClick={toggleCollapse}
        cursor='pointer'
      >
        <SrBox
          styleName={classNames('iconContainer', { isActive })}
        >
          <SrIcon className={`${icon}${isActive ? '-active' : ''}`} />
        </SrBox>
        <SrBox>
          <SrText
            weight='800'
            color={isActive ? null : 'greyMonochrome'}
            size='16'
            display='block'
          >
            {title}
          </SrText>
          <SrText
            weight='500'
            color={isActive ? null : 'greyMonochrome'}
            size='13'
            lineHeight='18.45px'
            width='100%'
          >
            {label}
          </SrText>
        </SrBox>
        <SrIcon
          className={isCollapsed ? 'caret-down' : 'caret-up'}
          styleName={classNames('arrow-dropdown')}
        />
      </SrFlex>
      {!isCollapsed && (
        <>
          <SrBox
            margin='32px 0'
          >
            {children}
          </SrBox>
        </>
      )}
    </SrBox>
  );
};

SrCollapsibleOption.propTypes = {
  icon: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  label: PropTypes.string,
  changeBackground: PropTypes.bool,
  initialCollapsedState: PropTypes.bool,
  isActive: PropTypes.bool,
  children: PropTypes.node,
};

export default SrCollapsibleOption;
